import React from 'react';

const LogoIManage = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#0066CC"/>
    <path d="M14 16H20L24 24L28 16H34L26 32L14 16Z" fill="white"/>
    <circle cx="32" cy="36" r="4" fill="#00C853"/>
  </svg>
);

export default LogoIManage;
